import React from "react";
import {
  formatCurrency,
  formatInteger,
  formatPercent,
  paymentTypeColor,
  paymentTypeLabel,
} from "./dashboardFormat";

// Receita por meio de pagamento, com a taxa de conversão de cada um.
//
// A conversão ao lado do valor é o ponto: o boleto costuma aparecer com receita
// pequena, e só a conversão explica que não é falta de procura, é abandono.

export default function PaymentTypeChart({ paymentTypes = [] }) {
  if (paymentTypes.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        Nenhuma transação registrada para este evento.
      </div>
    );
  }

  const biggest = Math.max(...paymentTypes.map((row) => row.amount), 1);

  return (
    <div>
      {paymentTypes.map((row) => {
        const width = row.amount > 0 ? Math.max(2, Math.round((row.amount / biggest) * 100)) : 2;

        return (
          <div key={row.type} className="mb-3">
            <div className="d-flex justify-content-between align-items-baseline mb-1">
              <span style={{ fontSize: "13px", fontWeight: 600, color: "#1f2937" }}>
                {paymentTypeLabel(row.type)}
              </span>
              {/* Valor numa coluna própria alinhada à direita, com `tabular-nums`:
                  é assim que Pix, cartão e boleto ficam comparáveis de relance. */}
              <span
                style={{
                  fontSize: "12.5px",
                  color: "#495057",
                  minWidth: "118px",
                  textAlign: "right",
                  fontVariantNumeric: "tabular-nums",
                }}
              >
                {formatCurrency(row.amount)}
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ flexGrow: 1, height: "10px", background: "#eff2f7", borderRadius: "5px" }}>
                <div
                  style={{
                    width: `${width}%`,
                    height: "10px",
                    background: paymentTypeColor(row.type),
                    borderRadius: "5px",
                  }}
                />
              </div>
            </div>
            <div style={{ fontSize: "11.5px", color: "#74788d", marginTop: "4px" }}>
              {formatInteger(row.paidTransactions)} de {formatInteger(row.transactions)} transações viraram pagamento
              {" · "}
              <span style={{ fontWeight: 600, color: row.conversionRate < 0.5 ? "#b42318" : "#74788d" }}>
                {formatPercent(row.conversionRate)}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
